import React, { ComponentProps } from "react";
import ReactDOM from "react-dom";
import reactToWebComponent from "react-to-webcomponent";
import { ThemeProvider } from "styled-components";
import PropTypes from "prop-types";

import { ThemeButton, ButtonIconContent } from "@ibinder/ui-common-core";
import { buttonTypes, iBinderMainTheme } from "@ibinder/ui-common-styles";

import {
  appleAppStore,
  fileCopy,
  googlePlayStore,
  print
} from "@ibinder/common-icons";

interface ButtonProps
  extends Omit<
    ComponentProps<typeof ThemeButton>,
    "noPadding" | "useOriginalSVGColor" | "disabled"
  > {
  icon?: string;
  noPadding?: "false" | "true";
  useSvgColor?: "false" | "true";
  disabled?: "false" | "true";
}

const icons: Record<string, JSX.Element> = {
  appleAppStore,
  fileCopy,
  googlePlayStore,
  print
};

const Index = ({
  buttonType = buttonTypes.Default,
  icon,
  label = "",
  name = "",
  type = "submit",
  value = "",
  noPadding = "false",
  useSvgColor = "false",
  disabled = "false"
}: ButtonProps) => {
  return (
    <ThemeProvider theme={iBinderMainTheme}>
      <ThemeButton
        {...{
          buttonType,
          name,
          type,
          noPadding: JSON.parse(noPadding),
          useOriginalSVGColor: JSON.parse(useSvgColor),
          value,
          disabled: JSON.parse(disabled)
        }}
      >
        {icon ? (
          <ButtonIconContent>
            {icons[icon]}
            <span>{label}</span>
          </ButtonIconContent>
        ) : (
          label
        )}
      </ThemeButton>
    </ThemeProvider>
  );
};

Index.propTypes = {
  buttonType: PropTypes.string,
  icon: PropTypes.string,
  label: PropTypes.string.isRequired,
  name: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string,
  noPadding: PropTypes.oneOf(["true", "false"]),
  useSvgColor: PropTypes.oneOf(["true", "false"]),
  disabled: PropTypes.oneOf(["true", "false"])
};

customElements.define(
  "ibinder-button",
  // @ts-ignore
  reactToWebComponent(Index, React, ReactDOM)
);
